import { FC } from 'react';

import BeneficiarySocietyMetrics from './BeneficiarySocietyMetrics';
import BeneficiarySocietyActionButtons from './BeneficiarySocietyActionButtons';
import BeneficiarySocietyChartSection from './BeneficiarySocietyChartSection';
import BeneficiarySocietyHeader from './BeneficiarySocietyHeader';
import { useBeneficiarySociety } from './hooks/useBeneficiarySociety';
import { BeneficiarySocietyProps } from './types/BeneficiarySocietyTypes';

import './BeneficiarySociety.scss';

const BeneficiarySociety: FC<BeneficiarySocietyProps> = (props) => {
  const { data, actions } = useBeneficiarySociety(props);

  const showChart =
    data.incentivesValues?.length > 0 &&
    data.vestingValues?.length > 0 &&
    data.hasIncentiveChart;

  return (
    <div className="card-inner">
      <div className="card-inner-group" data-simplebar="init">
        <div className="simplebar-wrapper beneficiary-society-simplebar-wrapper">
          <div className="simplebar-content beneficiary-society-simplebar-content">
            <BeneficiarySocietyHeader
              beneficiary={data.beneficiary}
              society={data.society}
            />

            <BeneficiarySocietyActionButtons
              hasTenderOffers={data.tenderOffersData.hasTenderOffers}
              hasIncentivesMarketEnabled={data.hasIncentivesMarketEnabled}
              isAcceptButtonVisible={data.isAcceptButtonVisible}
              onSeeOffers={actions.handleSeeOffers}
              onOpenIncentivesMarket={actions.handleOpenIncentivesMarket}
              onGoToPlansTab={() => actions.setPage(2)}
            />

            <BeneficiarySocietyMetrics
              beneficiary={data.beneficiary}
              society={data.society}
              summary={data.summary}
              decimalScale={data.decimalScale}
              onChangePage={actions.setPage}
            />

            {showChart ? (
              <BeneficiarySocietyChartSection
                chartData={data.chartData}
                chartOptions={data.chartOptions}
                isMobile={data.isMobile}
                societyValue={data.societyValue}
                valuation={data.valuation}
                onChangeSlider={actions.handleChangeSlider}
                onOpenSellView={actions.handleOpenSellView}
              />
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BeneficiarySociety;
